import axios from "axios";

const USER_KEY = "ipviewer-user";
const TOKEN_KEY = "ipviewer-token";
const WORKSPACE_KEY = "ipviewer-workspace";

const SORT_SCORES = {
  "EP-A1": 140,
  "EP-B2": 130,
  WO: 120,
  "AT-A": 110,
  "AT-B": 100,
  "DE-A": 90,
  "DE-B": 80,
  "US-A": 70,
  "US-B": 60,
  GB: 50,
  FR: 40,
  ES: 30,
  CN: 20,
  JP: 10,
};

export class Api {
  // note this is no a constructor but
  init(options) {
    this.ready = true;
    this.base = options.base;
    this.publicBase = options.publicBase;
    this.user = null;
    this.token = null;
    this.workspace = null;
    console.log("init api", options);
  }
  getAuthUser = () => {
    let user = this.user;
    if (window.localStorage && !this.user) {
      user = window.localStorage.getItem(USER_KEY);
      user = user ? JSON.parse(user) : null;
    }
    return user;
  };
  getAuthWorkspace = () => {
    let workspace = this.workspace;
    if (window.localStorage && !this.workspace) {
      workspace = window.localStorage.getItem(WORKSPACE_KEY);
      workspace = workspace ? JSON.parse(workspace) : null;
    }
    return workspace;
  };
  getToken = () => {
    let token = this.token;
    if (!token && window.localStorage) {
      token = window.localStorage.getItem(TOKEN_KEY);
    }
    return token;
  };
  logout = async () => {
    this.user = null;
    this.token = null;
    if (window.localStorage) {
      window.localStorage.setItem(WORKSPACE_KEY, null);
      window.localStorage.setItem(USER_KEY, null);
      window.localStorage.setItem(TOKEN_KEY, null);
    }
  };
  decodeToken = ({ token }) => {
    let base64Url = token.split(".")[1];
    let base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(window.atob(base64));
  };
  login = async ({ email, password, workspaceId, workspaceSlug }) => {
    // TODO: implement login auth call
    let { accessToken: token } = await this.POST("auth/login", {
      email,
      password,
      workspaceId,
      workspaceSlug,
    });
    const user = this.decodeToken({ token });
    console.log("user", user);
    console.log("logged in", email, password, workspaceId, workspaceSlug);
    let workspace = await this.getWorkspace({ workspaceSlug });

    console.log("got token", token, workspace);
    if (window.localStorage) {
      window.localStorage.setItem(WORKSPACE_KEY, JSON.stringify(workspace));
      window.localStorage.setItem(USER_KEY, JSON.stringify(user));
      window.localStorage.setItem(TOKEN_KEY, token);
    }
    this.user = user;
    this.token = token;
    this.workspace = workspace;
    return user;
  };
  getWorkspaces = async ({ email }) => {
    let workspaces = await this.GET("auth/workspaces", { email });
    return workspaces.map(this.setWorkspaceImageUrls);
  };
  getWorkspace = async ({ workspaceSlug }) => {
    let workspace = await this.GET(`auth/workspaces/${workspaceSlug}`);
    return this.setWorkspaceImageUrls(workspace);
  };
  setWorkspaceImageUrls = (workspace) => {
    workspace.logoFile.key = `${this.publicBase}${workspace.logoFile.key}`;
    workspace.backgroundFile.key = `${this.publicBase}${workspace.backgroundFile.key}`;
    workspace.faviconFile.key = `${this.publicBase}${workspace.faviconFile.key}`;
    return workspace;
  };

  // imports

  startImportPipeLine = (data) => {
    console.log("import data", data);

    let form = new FormData();
    Object.keys(data).forEach((key) => {
      form.append(key, data[key]);
    });

    return this.POST("imports", form);
  };

  // Users CRUD
  getUsers = async ({
    page,
    perPage,
    search,
    workspaceId,
    organizationId,
    sortBy,
    sortDirection,
  }) => {
    return this.GET("users", {
      page,
      perPage,
      search,
      workspaceId,
      organizationId,
      sortBy,
      sortDirection,
    });
  };
  getOneUser = async ({ userId }) => {
    return this.GET(`users/${userId}`);
  };
  updateUser = async ({
    userId,
    email,
    password,
    firstName,
    lastName,
    organizationId,
    role,
  }) => {
    return this.PUT(`users/${userId}`, {
      email,
      password,
      firstName,
      lastName,
      organizationId,
      role,
    });
  };
  createUser = async ({
    firstName,
    lastName,
    email,
    password,
    organizationId,
    role,
    workspaceId,
  }) => {
    return this.POST("users", {
      firstName,
      lastName,
      email,
      password,
      organizationId,
      role,
      workspaceId,
    });
  };
  getUserRoles = async () => {
    return this.GET("users/roles");
  };
  deleteUser = async ({ userId }) => {
    return this.DELETE(`users/${userId}`);
  };

  // ORGANIZATIONS CRUD
  getOrganizations = async ({
    page,
    perPage,
    search,
    workspaceId,
    sortBy,
    sortDirection,
  }) => {
    return this.GET("organizations", {
      page,
      perPage,
      search,
      workspaceId,
      sortDirection,
      sortBy,
    });
  };
  getOneOrganization = async ({ organizationId }) => {
    return this.GET(`organizations/${organizationId}`);
  };
  createOrganization = async ({ name }) => {
    return this.POST("organizations", { name });
  };
  updateOrganization = async ({ organizationId, name }) => {
    return this.PUT(`organizations/${organizationId}`, { name });
  };
  deleteOrganization = async ({ organizationId }) => {
    return this.DELETE(`organizations/${organizationId}`);
  };

  // FOLDERS CRUD
  getFolders = async ({
    type,
    page,
    perPage,
    search,
    sortBy,
    sortDirection,
    organizationId,
    workspaceId,
  }) => {
    return this.GET("folders", {
      type,
      page,
      perPage,
      search,
      sortBy,
      sortDirection,
      organizationId,
      workspaceId,
    });
  };

  getImports = async ({
    type,
    page,
    perPage,
    search,
    sortBy,
    sortDirection,
    workspaceId,
    organizationId,
  }) => {
    return this.GET("imports", {
      type,
      page,
      perPage,
      search,
      sortBy,
      sortDirection,
      workspaceId,
      organizationId,
    });
  };

  getImport = async ({ importId }) => {
    return this.GET("imports/" + importId, {});
  };
  restartImport = async ({ importId }) => {
    return this.POST(`imports/${importId}/start`);
  };
  pauseImport = async ({ importId }) => {
    return this.POST(`imports/${importId}/pause`);
  };
  updateFolder = async ({ folderId, name, slug, organizationId, userIds }) => {
    return this.PUT(`folders/${folderId}`, {
      name,
      slug,
      organizationId,
      userIds,
    });
  };
  getOneFolder = async ({ folderId }) => {
    return this.GET(`folders/${folderId}`);
  };
  createFolder = async ({ name, organizationId, slug, type, userIds }) => {
    return this.POST("folders/", { name, organizationId, slug, type, userIds });
  };
  deleteFolder = async ({ folderId }) => {
    return this.DELETE(`folders/${folderId}`);
  };

  getDocumentCollectionViews = async ({
    folderId,
    page,
    perPage,
    search,
    tags,
    sortBy,
    sortDirection,
  }) => {
    // TODO: reconsider if client side image url generation is a good idea
    let { documentCollectionViews, total } = await this.GET(
      "documents/collections/views/",
      { folderId, page, perPage, search, tags, sortBy, sortDirection }
    );
    return {
      documentCollectionViews: documentCollectionViews
        .map(this.setDocumentCollectionViewImageUrls)
        .map(this.sortDocuments),
      total,
    };
  };
  getDocumentCollectionView = async ({ documentCollectionViewId }) => {
    const url = `documents/collections/views/${documentCollectionViewId}`;
    let cancelToken = this.getCancelToken("getDocumentCollectionView", url);

    let documentCollectionView = await this.GET(url, {}, { cancelToken });
    if (!documentCollectionView) return;
    documentCollectionView = this.setDocumentCollectionViewImageUrls(
      documentCollectionView
    );
    return this.sortDocuments(documentCollectionView);
  };
  getDocumentSortScore(document) {
    let { externalDocumentId } = document;
    let country = externalDocumentId.split(".")[0];
    let kindCode = externalDocumentId.split(".")[2];
    let sortCode = country;
    if (kindCode) {
      sortCode += "-" + kindCode.substr(0, country === "EP" ? 2 : 1);
    }
    return SORT_SCORES[sortCode] || SORT_SCORES[country] || 1;
  }
  sortDocuments = (documentCollectionView) => {
    documentCollectionView.documents = documentCollectionView.documents.sort(
      (a, b) => {
        let scoreA = this.getDocumentSortScore(a);
        let scoreB = this.getDocumentSortScore(b);
        return scoreA > scoreB ? -1 : 1;
      }
    );
    return documentCollectionView;
  };
  updateDocumentCollectionViewTags = async ({
    documentCollectionViewId,
    tags,
  }) => {
    return this.PUT(
      `documents/collections/views/${documentCollectionViewId}/tags`,
      tags
    );
  };
  updateDocumentCollectionViewVisible = async ({
    documentCollectionViewId,
    visible,
  }) => {
    return this.PUT(
      `documents/collections/views/${documentCollectionViewId}/visible`,
      { visible }
    );
  };
  getDocumentCollectionViewComments = async ({ documentCollectionViewId }) => {
    const url = `documents/collections/views/${documentCollectionViewId}/comments`;
    let cancelToken = this.getCancelToken(
      "getDocumentCollectionViewComments",
      url
    );
    return this.GET(url, { cancelToken });
  };

  createDocumentCollectionViewComment = async ({
    documentCollectionViewId,
    text,
    documentId,
  }) => {
    return this.POST(
      `documents/collections/views/${documentCollectionViewId}/comments`,
      {
        text,
        documentId,
      }
    );
  };
  updateDocumentCollectionViewComment = async ({
    documentCollectionViewId,
    commentId,
    text,
    status,
    documentId,
  }) => {
    return this.PUT(
      `documents/collections/views/${documentCollectionViewId}/comments/${commentId}`,
      {
        text,
        status,
        documentId,
      }
    );
  };
  setDocumentCollectionViewImageUrls = (documentCollectionView) => {
    documentCollectionView.masterDocument = this.setDocumentImageUrls(
      documentCollectionView.masterDocument
    );
    documentCollectionView.documents = documentCollectionView.documents.map(
      this.setDocumentImageUrls
    );
    return documentCollectionView;
  };
  setDocumentImageUrls = (document) => {
    if (document && document.meta && document.meta.Images) {
      document.meta.Images = document.meta.Images.map((image) => {
        image.keys = image.keys.map((key) => {
          return `${this.publicBase}${key}`;
        });
        return image;
      });
    }
    return document;
  };
  getDocument = async ({ documentId }) => {
    let url = `documents/${documentId}`;
    let cancelToken = this.getCancelToken("getDocument", url);
    let document = await this.GET(url, {}, { cancelToken });
    if (!document) return;
    return this.setDocumentImageUrls(document);
  };
  GET = async (endpoint, data, options) => {
    return this.request("get", endpoint, data, options);
  };
  POST = async (endpoint, data, options) => {
    return this.request("post", endpoint, data, options);
  };
  PUT = async (endpoint, data, options) => {
    return this.request("put", endpoint, data, options);
  };
  DELETE = async (endpoint, data, options) => {
    return this.request("delete", endpoint, data, options);
  };
  getCancelToken = (id, url) => {
    this.cancelTokens = this.cancelTokens || {};
    this.tokenUrls = this.tokenUrls || {};
    if (this.cancelTokens[id]) {
      console.log("CANCEL REQUEST", id, this.tokenUrls[id]);
      this.cancelTokens[id].cancel();
    }
    let token = axios.CancelToken.source();
    this.cancelTokens[id] = token;
    this.tokenUrls[id] = url;
    return token;
  };
  request = async (method, endpoint, data, options = {}) => {
    if (!this.ready) {
      throw new Error("you tried to use the api before it was initialized");
    }

    const { cancelToken } = options;
    try {
      let config = {
        method: method,
        url: this.base + endpoint,
        cancelToken: cancelToken && cancelToken.token,
      };
      if (method === "get") {
        config.params = data;
      } else {
        config.data = data;
      }
      let token = this.getToken();
      console.log("request token", token);
      if (token) {
        config.headers = {
          Authorization: "bearer " + token,
        };
      }

      console.log("config", config);
      const result = await axios(config);
      return result && result.data;
    } catch (error) {
      if (axios.isCancel(error)) {
        return null;
      } else if (error.response && error.response.status === 401) {
        this.logout();
        window.location.reload();
        throw error;
      } else if (error.response) {
        console.log("error message", error.response);
        let errorMessage = error.response.statusText;
        if (error.response.data && error.response.data.error) {
          const { code, message } = error.response.data.error;
          errorMessage = `Fehlercode:${code} - ${message}`;
        }
        alert(errorMessage);
      } else {
        throw error;
      }
    }
  };
}
export const api = new Api({});

export default api;



// WEBPACK FOOTER //
// ./src/lib/api.js